import MobileSheetModal from "./MobileSheetModal"

function SparklesIcon({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3Z" />
    </svg>
  )
}

function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
  )
}

// The Pro upsell, raised by tapping a locked module/eye option. Tapping a lock
// must never change the design state — the sheet is the entire response, so a
// visitor who dismisses it is exactly where they were.
//
// Plasma, not voltage: this is the one place the secondary accent leads, per
// the brand rule that premium/Pro affordances are plasma and primary CTAs
// never are.
export default function MobileProSheet({ open, onClose, onUpgrade }) {
  return (
    <MobileSheetModal open={open} onClose={onClose} label="Upgrade to Pro">
      <span className="inline-flex h-[42px] w-[42px] items-center justify-center rounded-[13px] bg-plasma text-white">
        <SparklesIcon />
      </span>
      <h3 className="mt-1 font-display text-lg font-bold tracking-tight">Shapes are a Pro thing.</h3>
      <p className="text-sm leading-relaxed text-[color:var(--text-secondary)] text-pretty">
        Rounded dots, leaf corners, no Tango wordmark, and editing on every code you make.
        $10 a month, or $100 a year.
      </p>
      <div className="mt-1.5 flex flex-col gap-1.5">
        <button
          type="button"
          onClick={onUpgrade}
          className="inline-flex min-h-[50px] w-full items-center justify-center gap-2 rounded-md bg-plasma text-base font-semibold text-white shadow-plasma transition hover:bg-plasma-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-voltage focus-visible:ring-offset-2"
        >
          Go Pro <ArrowRightIcon />
        </button>
        <button
          type="button"
          onClick={onClose}
          className="min-h-[44px] text-sm font-semibold text-[color:var(--text-secondary)] underline underline-offset-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-voltage focus-visible:ring-offset-2 rounded"
        >
          Keep the square code
        </button>
      </div>
    </MobileSheetModal>
  )
}
